<style lang="scss" src='./TaskBoard.scss' scoped></style>
<template src="./TaskBoard.html"></template>

<script>
import { Consts } from 'gw-js-lib';
import { isEmpty } from 'lodash';
import { GetTask } from "@/api/api";

import {
  mapState,
  mapActions,
  mapMutations,
  mapGetters,
} from 'vuex';

import TaskDetails from './details/TaskDetails.vue';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
import RefreshButton from '@/components/refreshButton/RefreshButton.vue';
import CommonComponent from '@/components/utils/CommonComponent.vue';

export default {
  name: 'TaskBoard',
  extends: CommonComponent,
  components: {
    TaskDetails,
    UserAvatar,
    RefreshButton
  },
  data() {
    return {
      comments: null,
      tasksUpdateInterval: null,
      maxHeightTask: 600,
    };
  },
  computed: {
    ...mapState('TaskBoard', ['tasks', 'taskSelected', 'filterStatusList', 'taskFilterStatus', 'loading']),
    ...mapGetters('TaskBoard', ['getTasksFiltered', 'getTaskLoading']),
  },
  watch: {
    taskSelected() {
      document.getElementsByClassName('tasks-list-container')[0].scrollTop = 0;
    },
    taskFilterStatus() {
      document.getElementsByClassName('tasks-list-container')[0].scrollTop = 0;
    },
    course() {
      this.loadData();
    },
  },
  methods: {
    ...mapActions('TaskBoard', ['getAllTasks']),
    ...mapMutations('TaskBoard', ['setTask', 'setUserId', 'setCourseId', 'setTasksFilter']),
    ...mapMutations(['setTaskAlert']),
    startIntervalToRefreshTasks() {
      this.tasksUpdateInterval = window.setInterval(this.redo, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

    adjustTaskListHeight() {
      const self = this;
      // eslint-disable-next-line
      const taskHeightInterval = setInterval(function() {
        if (self.$refs.tasksListContainer) {
          self.maxHeightTask = window.innerHeight - 50 - (self.$refs.tasksListContainer.getBoundingClientRect().top);
        }
      }, 100);
      // eslint-disable-next-line
      setTimeout(function() {
        clearInterval(taskHeightInterval);
      }, 5000);
    },

    refresh() {
      this.getAllTasks();
    },

    redo(){
      // Pass true to hide loading
      this.getAllTasks(true)
    },

    loadData(){
      this.setTasksFilter(Consts.TaskStatus.PENDING);
      this.adjustTaskListHeight();
      this.startIntervalToRefreshTasks();
      this.setCourseId(this.course.course_id);
      if (this.user.user_type && (this.user.user_type.type_id === Consts.UserType.STAFF || this.user.user_type.type_id === Consts.UserType.IRRIGATION_SPECIALIST)) {
        this.setUserId(this.user.user_id);
      }
      this.getAllTasks();
    }
  },

  beforeMount() {
    this.setShowMenu(true);
    this.setShowBackground(true);
  },

  async mounted() {
    this.loadData();
    if(!isEmpty(this.$route.params)){
      this.setTasksFilter(this.$route.params.tab);
      if(this.$route.params.taskId){
        await GetTask(this.$route.params.taskId).then((response) => {
          this.setTask(response);
        });
      }
    }
  },
  beforeDestroy() {
    this.setTaskAlert({});
    window.clearInterval(this.tasksUpdateInterval);
  },
};
</script>
